var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      (_vm.activity.completed &&
        !_vm.activity.cancelled &&
        !_vm.activity.drafted) ||
      (_vm.isNoShow(_vm.activity) &&
        _vm.activity.completed &&
        !_vm.activity.cancelled &&
        !_vm.activity.drafted)
        ? _c("Badge", {
            staticClass: "w-fit capitalize customBadgeWidth",
            attrs: {
              color: _vm.checkOutStatusColor(_vm.activity),
              value: _vm.checkOutStatus(_vm.activity),
              showIcon: _vm.showIconForStatusCheckOut(_vm.activity),
              styleClasses: _vm.checkOutStatusClass(_vm.activity),
            },
          })
        : _vm._e(),
      !_vm.activity.completed &&
      !_vm.activity.drafted &&
      !_vm.activity.cancelled &&
      _vm.hasAssignne(_vm.activity)
        ? _c("Badge", {
            staticClass: "w-fit customBadgeWidth capitalize",
            attrs: {
              color: _vm.checkInStatusColor(_vm.activity),
              value: _vm.checkInStatus(_vm.activity),
              showIcon: _vm.showIconForStatus(_vm.activity),
              styleClasses: _vm.checkInStatusClass(_vm.activity),
            },
          })
        : _vm._e(),
      _vm.activity.cancelled
        ? _c("Badge", {
            staticClass: "text-badge w-fit capitalize customBadgeWidth",
            attrs: {
              color: _vm.BadgeColor.WARNING,
              value: "Cancelled",
              styleClasses: "py-0.5 px-2",
            },
          })
        : _vm._e(),
      _vm.activity.drafted
        ? _c("Badge", {
            attrs: {
              value: "Draft",
              styleClasses:
                "text-storm-gray bg-gray-tabs capitalize customBadgeWidth py-0.5 px-2",
            },
          })
        : _vm._e(),
      !_vm.activity.completed && !_vm.hasAssignne(_vm.activity)
        ? _c("Badge", {
            staticClass: "text-badge w-fit capitalize customBadgeWidth",
            attrs: {
              value: "Open",
              showIcon: true,
              color: _vm.BadgeColor.INTERNAL,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }